import Compact from "./New/Compact";
import Res from "./New";
import { Action } from "./New/Actions";

function Reservation({
  ...props
}: {
  actions?: Action[];
  className?: string;
  compact?: boolean;
  hideLocationString?: boolean;
  hideSubFares?: boolean;
  repricing?: boolean;
  res: be.Reservation;
  serviceArea?: number;
  shiftPickupDropoff?: boolean;
  vertical?: boolean;
}): JSX.Element | null {
  return props.compact ? <Compact {...props} /> : <Res {...props} />;
}

export default Reservation;
export type { Action };
